import React from "react";

export const TimeLineHeader = ({
  headerText,
  subHeaderText,
  onClick,
  onKeyDown,
  expanded
}) => {
  return (
    <div
      onClick={onClick}
      onKeyDown={onKeyDown}
      className="timeline-header"
      tabIndex={0}
    >
      <span>
        {headerText}: {subHeaderText}
      </span>
      <span className={expanded ? "toggler" : "toggler closed"} />
    </div>
  );
};
